import UtilArray from "@/utils/UtilArray.mjs";
import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import UtilNumber from "@/utils/UtilNumber";
import UtilSequence from "@/utils/UtilSequence.mjs";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    async criaRecebimento(contaAReceberRecebimentoValores = {}){

        let contaAReceber;
        let contaAReceberNovoRecebimento;

        try{

            //==================================================================//
            //========================= Pega Conta a Receber ===================//
            //==================================================================//

            let contaAReceberID = contaAReceberRecebimentoValores?.contaAReceber;

            contaAReceber = await ERP.getOneById(Schema.CONTAS_A_RECEBER, contaAReceberID);
            if(contaAReceber.status != 200){
                throw contaAReceber;
            }

            //==================================================================//
            //========= Pega os Recebimentos de Conta a Receber ================//
            //==================================================================//

            let contaAReceberRecebimentosIDs = contaAReceber?.data?.recebimentos || [];

            let contaAReceberRecebimentos = await ERP.getManyById(Schema.CONTAS_A_RECEBER_RECEBIMENTOS, contaAReceberRecebimentosIDs);

            //==================================================================//
            //==== Ordena os Recebimentos da Contas a Receber por Sequencia ====//
            //==================================================================//

            contaAReceberRecebimentos.data = contaAReceberRecebimentos?.data?.sort((recebimento_A, recebimento_B)=>{

                return UtilNumber.toNumber(recebimento_A.sequencia) - UtilNumber.toNumber(recebimento_B.sequencia);

            });

            //==================================================================//
            //======= Pega o Ultimo Recebimento de Conta a Receber =============//
            //==================================================================//

            let contaAReceberUltimoRecebimento = UtilArray.getLast(contaAReceberRecebimentos?.data);

            //========================================================================//
            //====== Pega a Sequencia do Ultimo Recebimento de Conta a Receber =======//
            //========================================================================//

            let contaAReceberUltimoRecebimentoSequencia = contaAReceberUltimoRecebimento?.sequencia;

            //==================================================================//
            //===== Pega Sequencia do Recebimento Novo da Conta a Receber ======//
            //==================================================================//

            let contaAReceberNovoRecebimentoSequencia = UtilNumber.getNextSequence({
                valor: contaAReceberUltimoRecebimentoSequencia,
                preencher:5,
            });

            //==================================================================//
            //=== Valida Dados Necessários para Criar um Novo Recebimento ======//
            //==================================================================//

            //===> contaAReceberRecebimentoJob
            let contaAReceberRecebimentoJob = contaAReceberRecebimentoValores?.job ?? contaAReceber?.data?.job;
            if(!contaAReceberRecebimentoJob){
                throw `Recebimento da Conta a Receber ${contaAReceber?.data?.codigo} não pode ser criado sem um Job`;
            }

            //===> contaAReceberRecebimentoJobParcela
            let contaAReceberRecebimentoJobParcela = contaAReceberRecebimentoValores?.jobParcela ?? contaAReceber?.data?.jobParcela;
            if(!contaAReceberRecebimentoJobParcela){
                throw `Recebimento da Conta a Receber ${contaAReceber?.data?.codigo} não pode ser criado sem um Job Parcela`;
            }

            //===> contaAReceberRecebimentoCliente
            let contaAReceberRecebimentoCliente = contaAReceberRecebimentoValores?.cliente ?? contaAReceber?.data?.cliente;
            if(!contaAReceberRecebimentoCliente){
                throw `Recebimento da Conta a Receber ${contaAReceber?.data?.codigo} não pode ser criado sem um Cliente`;
            }

            //===> contaAReceberRecebimentoContaFinanceira
            let contaAReceberRecebimentoContaFinanceira = contaAReceberRecebimentoValores?.contaFinanceira ?? contaAReceber?.data?.contaFinanceira;
            if(!contaAReceberRecebimentoContaFinanceira){
                throw `Recebimento da Conta a Receber ${contaAReceber?.data?.codigo} não pode ser criado sem uma Conta Financeira`;
            }

            //===> contaAReceberRecebimentoDataVencimento
            let contaAReceberRecebimentoDataVencimento = contaAReceberRecebimentoValores?.dataVencimento ?? contaAReceber?.data?.dataVencimento;
            if(!contaAReceberRecebimentoDataVencimento){
                throw `Recebimento da Conta a Receber ${contaAReceber?.data?.codigo} não pode ser criado sem uma Data de Venicimento`;
            }

            //===> contaAReceberRecebimentoNotaFiscalEmitida
            let contaAReceberRecebimentoNotaFiscalEmitida = contaAReceberRecebimentoValores?.notaFiscalEmitida;
            if(!contaAReceberRecebimentoNotaFiscalEmitida){
                throw `Recebimento da Conta a Receber ${contaAReceber?.data?.codigo} não pode ser criado sem uma Nota Fiscal Emitida`;
            }

            //==================================================================//
            //========== Cria Novo Recebimento de Conta a Receber ==============//
            //==================================================================//

            let contaAReceberNovoRecebimentoValores = {
                sequencia: contaAReceberNovoRecebimentoSequencia,
                tipo: contaAReceberRecebimentoValores?.tipo,
                status: "Recebimento realizado",
                job: contaAReceberRecebimentoJob,
                jobParcela: contaAReceberRecebimentoJobParcela,
                cliente: contaAReceberRecebimentoCliente,
                notaFiscalEmitida: contaAReceberRecebimentoNotaFiscalEmitida,
                contaAReceber: contaAReceberID,
                contaFinanceira: contaAReceberRecebimentoContaFinanceira,
                dataCriacao: UtilDateTime.todayUTC(),
                dataVencimento: UtilDateTime.toFormatUTC({dateTime:contaAReceberRecebimentoDataVencimento}),
                porcentagemRecebimento: contaAReceberRecebimentoValores?.porcentagemRecebimento || 0,
                valorRecebimento: contaAReceberRecebimentoValores?.valorRecebimento || 0,
            }

            contaAReceberNovoRecebimento = await ERP.postOne(Schema.CONTAS_A_RECEBER_RECEBIMENTOS, contaAReceberNovoRecebimentoValores);
            if(contaAReceberNovoRecebimento.status != 200){
                throw contaAReceberNovoRecebimento;
            }

            console.log(contaAReceberNovoRecebimento);

            //==================================================================//
            //=========== Soma os Recebimentos da Conta a Receber ==============//
            //==================================================================//

            let contaAReceberValorRecebido = contaAReceberRecebimentos?.data?.reduce((acc,contaAReceberRecebimento)=>{

                if(contaAReceberRecebimento.status == "Recebimento realizado"){
                    acc += contaAReceberRecebimento.valorRecebimento;
                }

                return acc;

            },0); 

            contaAReceberValorRecebido += contaAReceberNovoRecebimento?.data?.valorRecebimento;

            //==================================================================//
            //========= Calcula o Valor Restante da Conta a Receber ============//
            //==================================================================//

            let contaAReceberValorRestante = contaAReceber.data.valorOriginal - contaAReceberValorRecebido;

            //==================================================================//
            //========= Determina se a Conta a Receber foi Realizada ===========//
            //==================================================================//

            let contaAReceberStatus = contaAReceberValorRestante == 0 ? "Realizada" : contaAReceber.data.status;

            //==================================================================//
            //========== Adiciona Recebimento Novo a Conta a Receber ===========//
            //==================================================================//

            let contaAReceberNovoRecebimentoID = contaAReceberNovoRecebimento?.data?.id;
            contaAReceberRecebimentosIDs.push(contaAReceberNovoRecebimentoID);

            let contaAReceberValores = {
                id: contaAReceberID,
                status: contaAReceberStatus,
                valorRecebido: contaAReceberValorRecebido,
                valorSaldo: contaAReceberValorRestante,
                recebimentos: contaAReceberRecebimentosIDs
            }

            contaAReceber = await ERP.patchOne(Schema.CONTAS_A_RECEBER, contaAReceberValores);
            if(contaAReceber.status != 200){
                throw contaAReceber;
            }

            console.log(contaAReceber);

        }catch(e){

            console.log(e);
            return contaAReceberNovoRecebimento;

        }

        return contaAReceberNovoRecebimento;

    },

    async criarRecebimentos(recebimentosNovosValores = []){

        let recebimentosNovos = {
            data: [],
            status: 200
        };

        try{

            //==================================================================//
            //=========== Criar Recebimentos de Contas a Receber ===============//
            //==================================================================//

            recebimentosNovos.data = await UtilSequence.each({
                list: recebimentosNovosValores,
                callback: async (recebimentoNovoValores)=>{

                    //==================================================================//
                    //================== Cria um Recebimento Novo ======================//
                    //==================================================================//

                    recebimentoNovoValores = {
                        notaFiscalEmitida: recebimentoNovoValores?.notaFiscalEmitida,
                        contaAReceber: recebimentoNovoValores?.contaAReceber,
                        tipo: "Recebimento",
                        jobParcela: recebimentoNovoValores?.jobParcela,
                        contaFinanceira: recebimentoNovoValores?.contaFinanceira,
                        dataVencimento: UtilDateTime.toFormatUTC({dateTime:recebimentoNovoValores?.dataVencimento}),
                        porcentagemRecebimento: recebimentoNovoValores?.porcentagemRecebimento,
                        valorRecebimento: recebimentoNovoValores?.valorRecebimento,
                    }

                    //==================================================================//
                    //================== Cria um Recebimento Novo ======================//
                    //==================================================================//

                    let recebimentoNovo = await this.criaRecebimento(recebimentoNovoValores);
                    if(recebimentoNovo.status != 200){
                        throw recebimentoNovo;
                    }

                    //==================================================================//
                    //======================== Pega Job Parcela ========================//
                    //==================================================================//

                    let jobParcelaID = recebimentoNovo?.data?.jobParcela;

                    let jobParcela = await ERP.getOneById(Schema.JOB_PARCELAS, jobParcelaID);
                    if(jobParcela.status != 200){
                        throw jobParcela;
                    }

                    //==================================================================//
                    //===================== Altera o Job Parcela =======================//
                    //==================================================================//

                    let jobParcelaValorRecebido = jobParcela?.data?.valorRecebido + recebimentoNovo?.data?.valorRecebimento;
                    let jobParcelaValorParaReceber = jobParcela?.data?.valorParaReceber - recebimentoNovo?.data?.valorRecebimento;

                    let jobParcelaValores = {
                        id: jobParcelaID,
                        tipo: "NF",
                        valorRecebido: jobParcelaValorRecebido,
                        valorParaReceber: jobParcelaValorParaReceber,
                    }

                    jobParcela = await ERP.patchOne(Schema.JOB_PARCELAS, jobParcelaValores);
                    if(jobParcela.status != 200){
                        throw jobParcela;
                    }

                    //==================================================================//
                    //==================== Pega a Conta a Receber ======================//
                    //==================================================================//

                    let contaAReceberID = recebimentoNovoValores.contaAReceber;

                    let contaAReceber = await ERP.getOneById(Schema.CONTAS_A_RECEBER, contaAReceberID);
                    if(contaAReceber.status != 200){
                        throw contaAReceber;
                    }

                    //==================================================================//
                    //================ Cria um Movimento Financeiro ====================//
                    //==================================================================//

                    let movimentoFinanceiroValores = {
                        descricao: `Gerado pela Conta a Receber ${contaAReceber?.data?.codigo}`,
                        dataMovimento: UtilDateTime.todayUTC(),
                        valorMovimento: recebimentoNovo?.data?.valorRecebimento,
                        contaFinanceira: recebimentoNovo?.data?.contaFinanceira,
                        contaAReceber: contaAReceber?.data?.id,
                        cliente: contaAReceber?.data?.cliente,
                        //Futuramente adicionar o Job a Conta a Pagar e implementar essa melhoria aqui.
                    }

                    let movimentoFinanceiro = await ERP.postOne(Schema.MOVIMENTO_FINANCEIRO, movimentoFinanceiroValores);
                    if(movimentoFinanceiro.status != 200){
                        throw movimentoFinanceiro;
                    }

                    console.log(movimentoFinanceiro);

                    //==================================================================//
                    //=================== Pega a Conta Financeira ======================//
                    //==================================================================//

                    let contaFinanceira = await ERP.getOneById(Schema.CONTAS_FINANCEIRAS, recebimentoNovo?.data?.contaFinanceira);
                    if(contaFinanceira.status != 200){
                        throw contaFinanceira;
                    }

                    //==================================================================//
                    //================= Altera a Conta Financeira ======================//
                    //==================================================================//

                    let contaFinanceiraNovoSaldo = contaFinanceira?.data?.saldo + recebimentoNovo?.data?.valorRecebimento;

                    let contaFinanceiraValores = {
                        id: recebimentoNovo?.data?.contaFinanceira,
                        saldo: contaFinanceiraNovoSaldo
                    }

                    contaFinanceira = await ERP.patchOne(Schema.CONTAS_FINANCEIRAS, contaFinanceiraValores);
                    if(contaFinanceira.status != 200){
                        throw contaFinanceira;
                    }

                    console.log(contaFinanceira);

                    return recebimentoNovo;

                }
            });

        }catch(e){

            console.log(e);
            recebimentosNovos.status = 500;
            return recebimentosNovos;

        }

        return recebimentosNovos;

    },

    async criarVinculo(vinculoValores = {}){

        let contaAReceberAvulsaNovoRecebimento;

        try{

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //========= Cria Recebimento de Conta a Receber Avulsa =============//
            //==================================================================//

            let notaFiscalEmitidaID = vinculoValores.notaFiscalEmitida;
            let contaAReceberAvulsaID = vinculoValores.contaAReceberAvulsa;

            let contaAReceberAvulsaNovoRecebimentoValores = {
                notaFiscalEmitida: notaFiscalEmitidaID,
                contaAReceber: contaAReceberAvulsaID,
                tipo: "Vinculo",
                porcentagemRecebimento: vinculoValores.porcentagemRecebimento,
                valorRecebimento: vinculoValores.valorRecebimento
            };

            contaAReceberAvulsaNovoRecebimento = await this.criaRecebimento(contaAReceberAvulsaNovoRecebimentoValores);
            if(contaAReceberAvulsaNovoRecebimento.status != 200){
                throw contaAReceberAvulsaNovoRecebimento;
            }

            let contaAReceberNovoRecebimentoID = contaAReceberAvulsaNovoRecebimento?.data?.id;

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //==================================================================//
            //================== Pega Nota Fiscal Emitida ======================//
            //==================================================================//

            let notaFiscalEmitida = await ERP.getOneById(Schema.NOTA_FISCAL_EMITIDA, notaFiscalEmitidaID);
            if(notaFiscalEmitida.status != 200){
                throw notaFiscalEmitida;
            }

            //==================================================================//
            //============= Pega Parcelas de Nota Fiscal Emitida  ==============//
            //==================================================================//

            let notaFiscalEmitidaParcelasIDs = notaFiscalEmitida?.data?.parcelas;

            let notaFiscalEmitidaParcelas = await ERP.getManyById(Schema.NOTA_FISCAL_EMITIDA_PARCELAS, notaFiscalEmitidaParcelasIDs);
            if(notaFiscalEmitidaParcelas.status != 200){
                throw notaFiscalEmitidaParcelas;
            }

            //==================================================================//
            //======== Pega IDs Contas a Receber de Nota Fiscal Emitida ========//
            //==================================================================//

            let notaFiscalEmitidaContasAReceberIDs = notaFiscalEmitidaParcelas?.data?.reduce((acc,notaFiscalEmitidaParcela)=>{

                acc.push(notaFiscalEmitidaParcela.contaAReceber);
                return acc

            },[]);

            //==================================================================//
            //========== Pega Contas a Receber de Nota Fiscal Emitida  =========//
            //==================================================================//

            let notaFiscalEmitidaContasAReceber = await ERP.getManyById(Schema.CONTAS_A_RECEBER, notaFiscalEmitidaContasAReceberIDs);
            if(notaFiscalEmitidaContasAReceber.status != 200){
                throw notaFiscalEmitidaContasAReceber;
            }

            //==================================================================//
            //========= Filtra Contas a Receber de Nota Fiscal Emitida  ========//
            //==================================================================//

            let notaFiscalEmitidaContasAReceberFiltradas = notaFiscalEmitidaContasAReceber?.data?.reduce((acc,notaFiscalEmitidaContaAReceber)=>{

                if(
                    notaFiscalEmitidaContaAReceber.status == "Prevista" &&
                    notaFiscalEmitidaContaAReceber.valorSaldo > 0
                ){
                    acc.push(notaFiscalEmitidaContaAReceber);
                }

                return acc;

            },[]);

            //==================================================================//
            //========= Ordena Contas a Receber de Nota Fiscal Emitida  ========//
            //==================================================================//

            let notaFiscalEmitidaContasAReceberOrdenadas = notaFiscalEmitidaContasAReceberFiltradas.sort((contaAReceber_A,contaAReceber_B)=>{

                return contaAReceber_A.parcela - contaAReceber_B.parcela;

            });

            //=============================================================================//
            //=== Soma o Valor Para Receber das Contas a Receber da Nota Fiscal Emitida ===//
            //=============================================================================//

            let notaFiscalEmitidaContasAReceberValorParaReceber = notaFiscalEmitidaContasAReceberOrdenadas.reduce((acc,notaFiscalEmitidaContaAReceber)=>{

                acc += notaFiscalEmitidaContaAReceber.valorSaldo;
                return acc;

            },0);

            //====================================================================//
            //========== Controla os Recebimento da Nota Fiscal Emitida ==========//
            //=== Cria Recebimentos de Contas a Receber da Nota Fiscal Emitida ===//
            //====================================================================//
            
            let notaFiscalEmitidaValorRecebendo = vinculoValores?.valorRecebimento;

            await UtilSequence.each({
                list:  notaFiscalEmitidaContasAReceberOrdenadas,
                callback: async (notaFiscalEmitidaContaAReceber)=>{

                    //====================================================================//
                    //====== Interrompa se o Recebimento foi completamente efetuado ======//
                    //====================================================================//

                    if(notaFiscalEmitidaValorRecebendo == 0){
                        return;
                    }
                    
                    //====================================================================//
                    //=== Cria Recebimentos de Contas a Receber da Nota Fiscal Emitida ===//
                    //====================================================================//

                    let notaFiscalEmitidaContaAReceberID = notaFiscalEmitidaContaAReceber?.id;

                    let valorRecebimento = UtilNumber.clamp(notaFiscalEmitidaValorRecebendo, 0, notaFiscalEmitidaContaAReceber.valorSaldo);

                    let porcentagemRecebimento = UtilNumber.getPercentage({
                        parte: valorRecebimento,
                        total: notaFiscalEmitidaContasAReceberValorParaReceber,
                        maximo: 100
                    });

                    valorRecebimento = UtilNumber.round(valorRecebimento);

                    let notaFiscalEmitidaContaAReceberRecebimentoValores = {
                        notaFiscalEmitida: notaFiscalEmitidaID,
                        contaAReceber: notaFiscalEmitidaContaAReceberID,
                        tipo: "Vinculo",
                        job: contaAReceberAvulsaNovoRecebimento?.data?.job,
                        jobParcela: contaAReceberAvulsaNovoRecebimento?.data?.jobParcela,
                        contaFinanceira: contaAReceberAvulsaNovoRecebimento?.data?.contaFinanceira,
                        valorRecebimento: valorRecebimento,
                        porcentagemRecebimento: porcentagemRecebimento,
                    };

                    let notaFiscalEmitidaContaAReceberRecebimento = await this.criaRecebimento(notaFiscalEmitidaContaAReceberRecebimentoValores);
                    if(notaFiscalEmitidaContaAReceberRecebimento.status != 200){
                        throw notaFiscalEmitidaContaAReceberRecebimento;
                    }
                    
                    //====================================================================//
                    //=============== Contabiliza o quanto já foi Recebido ===============//
                    //====================================================================//
                    
                    notaFiscalEmitidaValorRecebendo = notaFiscalEmitidaValorRecebendo - valorRecebimento;

                    //====================================================================//
                    //=========================== Cria Vinculo ===========================//
                    //========== Conta a Receber Avulsa X Nota Fiscal Emitida ============//
                    //====================================================================//

                    let notaFiscalEmitidaContaAReceberRecebimentoID = notaFiscalEmitidaContaAReceberRecebimento?.data?.id;

                    let vinculoValores = {
                        status: "Valido",
                        contaAReceberAvulsa: contaAReceberAvulsaID,
                        contaAReceberAvulsaRecebimento: contaAReceberNovoRecebimentoID,
                        notaFiscalEmitida: notaFiscalEmitidaID,
                        notaFiscalEmitidaContaAReceber: notaFiscalEmitidaContaAReceberID,
                        notaFiscalEmitidaContaAReceberRecebimento: notaFiscalEmitidaContaAReceberRecebimentoID,
                    }

                    let vinculo = await ERP.postOne(Schema.CONTAS_A_RECEBER_RECEBIMENTOS_VINCULOS, vinculoValores);
                    if(vinculo.status != 200){
                        throw vinculo;
                    }

                    console.log(vinculo);

                    return notaFiscalEmitidaContaAReceber;

                },
            });

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            
            //==================================================================//
            //================ Pega Conta a Receber Avulsa =====================//
            //==================================================================//

            let contaAReceberAvulsa = await ERP.getOneById(Schema.CONTAS_A_RECEBER, contaAReceberAvulsaID);
            if(contaAReceberAvulsa.status != 200){
                throw contaAReceberAvulsa;
            }

            //==================================================================//
            //===================== Altera Job Parcela =========================//
            //==================================================================//

            let jobParcelaID = contaAReceberAvulsa?.data?.jobParcela;

            let jobParcelaValores = {
                id: jobParcelaID,
                tipo: "NF"
            }

            let jobParcela = await ERP.patchOne(Schema.JOB_PARCELAS, jobParcelaValores);
            if(jobParcela.status != 200){
                throw jobParcela;
            }



        }catch(e){

            console.log(e);
            return contaAReceberAvulsaNovoRecebimento;

        }

        return contaAReceberAvulsaNovoRecebimento;

    },

}